const twoDigitTeaors = [
  {
    labelText: `01 '08 Növénytermesztés, állattenyésztés, vadgazdálkodás és kapcsolódó szolgáltatások`,
    teaorValue: '01'
  },
  {
    labelText: `02 '08 Erdőgazdálkodás`,
    teaorValue: '02'
  },
  {
    labelText: `03 '08 Halászat, halgazdálkodás`,
    teaorValue: '03'
  },
  {
    labelText: `05 '08 Szénbányászat`,
    teaorValue: '05'
  },
  {
    labelText: `06 '08 Kőolaj-, földgázkitermelés`,
    teaorValue: '06'
  },
  {
    labelText: `07 '08 Fémtartalmú érc bányászata`,
    teaorValue: '07'
  },
  {
    labelText: `08 '08 Egyéb bányászat`,
    teaorValue: '08'
  },
  {
    labelText: `09 '08 Bányászati szolgáltatás`,
    teaorValue: '09'
  },
  {
    labelText: `10 '08 Élelmiszergyártás`,
    teaorValue: '10'
  },
  {
    labelText: `11 '08 Italgyártás`,
    teaorValue: '11'
  },
  {
    labelText: `12 '08 Dohánytermék gyártása`,
    teaorValue: '12'
  },
  {
    labelText: `13 '08 Textília gyártása`,
    teaorValue: '13'
  },
  {
    labelText: `14 '08 Ruházati termék gyártása`,
    teaorValue: '14'
  },
  {
    labelText: `15 '08 Bőr, bőrtermék, lábbeli gyártása`,
    teaorValue: '15'
  },
  {
    labelText: `16 '08 Fafeldolgozás (kivéve: bútor), fonottáru gyártása`,
    teaorValue: '16'
  },
  {
    labelText: `17 '08 Papír, papírtermék gyártása`,
    teaorValue: '17'
  },
  {
    labelText: `18 '08 Nyomdai és egyéb sokszorosítási tevékenység`,
    teaorValue: '18'
  },
  {
    labelText: `19 '08 Kokszgyártás, kőolaj-feldolgozás`,
    teaorValue: '19'
  },
  {
    labelText: `20 '08 Vegyi anyag, termék gyártása`,
    teaorValue: '20'
  },
  {
    labelText: `21 '08 Gyógyszergyártás`,
    teaorValue: '21'
  },
  {
    labelText: `22 '08 Gumi-, műanyag termék gyártása`,
    teaorValue: '22'
  },
  {
    labelText: `23 '08 Nemfém ásványi termék gyártása`,
    teaorValue: '23'
  },
  {
    labelText: `24 '08 Fémalapanyag gyártása`,
    teaorValue: '24'
  },
  {
    labelText: `25 '08 Fémfeldolgozási termék gyártása`,
    teaorValue: '25'
  },
  {
    labelText: `26 '08 Számítógép, elektronikai, optikai termék gyártása`,
    teaorValue: '26'
  },
  {
    labelText: `27 '08 Villamos berendezés gyártása`,
    teaorValue: '27'
  },
  {
    labelText: `28 '08 Gép, gépi berendezés gyártása`,
    teaorValue: '28'
  },
  {
    labelText: `29 '08 Közúti jármű gyártása`,
    teaorValue: '29'
  },
  {
    labelText: `30 '08 Egyéb jármű gyártása`,
    teaorValue: '30'
  },
  {
    labelText: `31 '08 Bútorgyártás`,
    teaorValue: '31'
  },
  {
    labelText: `32 '08 Egyéb feldolgozóipari tevékenység`,
    teaorValue: '32'
  },
  {
    labelText: `33 '08 Ipari gép, berendezés, eszköz javítása`,
    teaorValue: '33'
  },
  {
    labelText: `35 '08 Villamosenergia-, gáz-, gőzellátás, légkondicionálás`,
    teaorValue: '35'
  },
  {
    labelText: `36 '08 Víztermelés, -kezelés, -ellátás`,
    teaorValue: '36'
  },
  {
    labelText: `37 '08 Szennyvíz gyűjtése, kezelése`,
    teaorValue: '37'
  },
  {
    labelText: `38 '08 Hulladékgazdálkodás`,
    teaorValue: '38'
  },
  {
    labelText: `39 '08 Szennyeződésmentesítés, egyéb hulladékkezelés`,
    teaorValue: '39'
  },
  {
    labelText: `41 '08 Épületek építése`,
    teaorValue: '41'
  },
  {
    labelText: `42 '08 Egyéb építmény építése`,
    teaorValue: '42'
  },
  {
    labelText: `43 '08 Speciális szaképítés`,
    teaorValue: '43'
  },
  {
    labelText: `45 '08 Gépjármű, motorkerékpár kereskedelme, javítása`,
    teaorValue: '45'
  },
  {
    labelText: `46 '08 Nagykereskedelem (kivéve: jármű, motorkerékpár`,
    teaorValue: '46'
  },
  {
    labelText: `47 '08 Kiskereskedelem (kivéve: gépjármű, motorkerékpár`,
    teaorValue: '47'
  },
  {
    labelText: `49 '08 Szárazföldi, csővezetékes szállítás`,
    teaorValue: '49'
  },
  {
    labelText: `50 '08 Vízi szállítás`,
    teaorValue: '50'
  },
  {
    labelText: `51 '08 Légi szállítás`,
    teaorValue: '51'
  },
  {
    labelText: `52 '08 Raktározás, szállítást kiegészítő tevékenység`,
    teaorValue: '52'
  },
  {
    labelText: `53 '08 Postai, futárpostai tevékenység`,
    teaorValue: '53'
  },
  {
    labelText: `55 '08 Szálláshely-szolgáltatás`,
    teaorValue: '55'
  },
  {
    labelText: `56 '08 Vendéglátás`,
    teaorValue: '56'
  },
  {
    labelText: `58 '08 Kiadói tevékenység`,
    teaorValue: '58'
  },
  {
    labelText: `59 '08 Film, video, televízióműsor gyártása, hangfelvétel-kiadás`,
    teaorValue: '59'
  },
  {
    labelText: `60 '08 Műsorösszeállítás, műsorszolgáltatás`,
    teaorValue: '60'
  },
  {
    labelText: `61 '08 Távközlés`,
    teaorValue: '61'
  },
  {
    labelText: `62 '08 Információ-technológiai szolgáltatás`,
    teaorValue: '62'
  },
  {
    labelText: `63 '08 Információs szolgáltatás`,
    teaorValue: '63'
  },
  {
    labelText: `64 '08 Pénzügyi közvetítés (kivéve: biztosítási, nyugdíjpénztári tevékenység`,
    teaorValue: '64'
  },
  {
    labelText: `65 '08 Biztosítás, viszontbiztosítás, nyugdíjalapok (kivéve: kötelező társadalombiztosítás`,
    teaorValue: '65'
  },
  {
    labelText: `66 '08 Egyéb pénzügyi tevékenység`,
    teaorValue: '66'
  },
  {
    labelText: `68 '08 Ingatlanügyletek`,
    teaorValue: '68'
  },
  {
    labelText: `69 '08 Jogi, számviteli, adószakértői tevékenység`,
    teaorValue: '69'
  },
  {
    labelText: `70 '08 Üzletvezetési, vezetői tanácsadás`,
    teaorValue: '70'
  },
  {
    labelText: `71 '08 Építészmérnöki tevékenység; műszaki vizsgálat, elemzés`,
    teaorValue: '71'
  },
  {
    labelText: `72 '08 Tudományos kutatás, fejlesztés`,
    teaorValue: '72'
  },
  {
    labelText: `73 '08 Reklám, piackutatás`,
    teaorValue: '73'
  },
  {
    labelText: `74 '08 Egyéb szakmai, tudományos, műszaki tevékenység`,
    teaorValue: '74'
  },
  {
    labelText: `75 '08 Állat-egészségügyi ellátás`,
    teaorValue: '75'
  },
  {
    labelText: `77 '08 Kölcsönzés, operatív lízing`,
    teaorValue: '77'
  },
  {
    labelText: `78 '08 Munkaerőpiaci szolgáltatás`,
    teaorValue: '78'
  },
  {
    labelText: `79 '08 Utazásközvetítés, utazásszervezés, egyéb foglalás`,
    teaorValue: '79'
  },
  {
    labelText: `80 '08 Biztonsági, nyomozói tevékenység`,
    teaorValue: '80'
  },
  {
    labelText: `81 '08 Építményüzemeltetés, zöldterület-kezelés`,
    teaorValue: '81'
  },
  {
    labelText: `82 '08 Adminisztratív, kiegészítő egyéb üzleti szolgáltatás`,
    teaorValue: '82'
  },
  {
    labelText: `84 '08 Közigazgatás, védelem; kötelező társadalombiztosítás`,
    teaorValue: '84'
  },
  {
    labelText: `85 '08 Oktatás`,
    teaorValue: '85'
  },
  {
    labelText: `86 '08 Humán-egészségügyi ellátás`,
    teaorValue: '86'
  },
  {
    labelText: `87 '08 Bentlakásos, nem kórházi ápolás`,
    teaorValue: '87'
  },
  {
    labelText: `88 '08 Szociális ellátás bentlakás nélkül`,
    teaorValue: '88'
  },
  {
    labelText: `90 '08 Alkotó-, művészeti, szórakoztató tevékenység`,
    teaorValue: '90'
  },
  {
    labelText: `91 '08 Könyvtári, levéltári, múzeumi, egyéb kulturális tevékenység`,
    teaorValue: '91'
  },
  {
    labelText: `92 '08 Szerencsejáték, fogadás`,
    teaorValue: '92'
  },
  {
    labelText: `93 '08 Sport-, szórakoztató, szabadidős tevékenység`,
    teaorValue: '93'
  },
  {
    labelText: `94 '08 Érdekképviselet`,
    teaorValue: '94'
  },
  {
    labelText: `95 '08 Számítógép, személyi, háztartási cikk javítása`,
    teaorValue: '95'
  },
  {
    labelText: `96 '08 Egyéb személyi szolgáltatás`,
    teaorValue: '96'
  },
  {
    labelText: `97 '08 Háztartási alkalmazottat foglalkoztató magánháztartás`,
    teaorValue: '97'
  },
  {
    labelText: `98 '08 Háztartás termék-előállítása, szolgáltatása saját fogyasztásra`,
    teaorValue: '98'
  }
]

export default twoDigitTeaors
